import { QueryClient } from "@tanstack/react-query";

const appQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 120000,
    },
  },
});

export default appQueryClient;
